export default () => ({
  entity: 'document',
  entities: 'documents',
  currentEntity: {},
  documents: [],
  showModal: false,
  documentSubmitted: [],
  errors: {
  },
  document: {
    document_status_id: null,
    document_status: null,
    extension: null,
    filename: null,
    label: null,
    name: null,
    required: null,
    slug: null,
    validity: null,
    attachment: {
      content: null,
      mime: null
    }
  },
    // never use prefix v1.
  prefixRouter: 'professional.company.documents'
})



// WEBPACK FOOTER //
// ./src/app/professional/company/documents/form/resources/data.js